import React from "react";
import { Navigate } from "react-router";
import Base from "./Base";

export default class PracticalText extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            type: props.Type,
            caller: props.Caller,
            data: null,
            loading: true,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();

        var p1 = this.httpPost("api/v1/practicaltext/get", {
            id: this.getCurrentFormId(),
        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.state.data = data;
            }
        });
        Promise.all([p1]).then((r) => {
            this.setState({
                loading: false,
            });
        });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();

        this.httpPost("api/v1/practicaltext/save", {
            id: this.state.id,
            text: this.state.data.record.text,
            type: this.state.type,
        }).then((data) => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                this.state.caller.refreshData();
                this.closeMe();
            } else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false,
                });
            }
        });
    }
    renderForm() {
        return (
            <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
                <div className="modal-backdrop fade in" style={{ height: "100%" }} onClick={(e) => this.closeMe()}></div>
                <div className="modal-dialog ui-draggable" style={{ minWidth: "90%" }}>
                    <div className="modal-content">
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={(e) => this.closeMe()} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                            <h4 className="modal-title">
                                محتوای متن
                            </h4>
                        </div>
                        <div className="modal-body" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label htmlFor="resultText" className="title1">متن:</label>
                                            <textarea style={{ "minHeight": "120px" }} defaultValue={this.state.data.record.text} onChange={e => this.state.data.record.text = e.target.value} autocomplete="off" type="text" className="form-control input-sm"></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default btn-smoke" onClick={(e) => this.closeMe()}>انصراف</button>
                            <button type="submit" name="bank_form_modal_submit" className="btn btn-success" onClick={e => this.save(e)}>ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect))
            return <Navigate to={this.state.redirect} />;

        let contents = this.state.loading
            ? this.renderLoading()
            : [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
            ];

        return contents;
    }
}